import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const planExportPageRoute: InvariantJiraRoute = {
	name: 'software-advanced-roadmaps',
	path: '/jira/plans/:planId/scenarios/:scenarioId/export',
};
